<!-- MIT License

Copyright (c) 2025 Brad Schick

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE. -->
<table mat-table [dataSource]="loops()" class="mat-elevation-z0 algtable">
  <ng-container matColumnDef="loop">
    <td mat-cell class="loop" *matCellDef="let loop">
      {{loop}}
    </td>
  </ng-container>
  <ng-container matColumnDef="algorithm">
    <td mat-cell class="alg" *matCellDef="let loop">
      <div class="mode">
      <mat-button-toggle-group [ngModel]="filledModes()[loop - 1]" aria-label="Cipher Algorithm"
        (ngModelChange)="onAlgorithmChange(loop, $event)">
        <mat-button-toggle class="algoption" value="AES-GCM">{{algDescription('AES-GCM')}}</mat-button-toggle>
        <mat-button-toggle class="algoption" value="X20-PLY">{{algDescription('X20-PLY')}}</mat-button-toggle>
        <mat-button-toggle class="algoption" value="AEGIS-256">{{algDescription('AEGIS-256')}}</mat-button-toggle>
      </mat-button-toggle-group>
      </div>
    </td>
  </ng-container>
  <tr mat-row *matRowDef="let row; columns: displayedColumns();"></tr>
</table>